<template>
  <div>
    <el-dialog
      :title="!uploading ? '上传文件' : '上传进度'"
      :visible.sync="showDialog"
      :before-close="close"
      @open="open"
      :destroy-on-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <!-- 自定的组件  选择目录和选择文件-->
      <upfile-step1
        ref="fileStep1"
        v-show="showSpeed"
        :uploading="uploading"
        @pushListFun="pushListFun"
        @removeList="removeList"
        @setDirId="setDirId"
      >
      </upfile-step1>
      <!-- 自定义组件 上传的列表 -->
      <upfile-step2
        @tryAgain="tryAgain"
        @remove="remove"
        :upList="upList"
        :speed="speed"
        :uploading="uploading"
        v-show="speed || uploading"
      >
      </upfile-step2>
      <div slot="footer" class="item_big footer" v-show="showSpeed">
        <div class="valueStyle">已添加{{ upList.length }}个</div>
        <div class="labelStyle">
          <el-button size="small" @click="close"> 取消</el-button>
          <el-button type="primary" size="small" @click="actionUpFile"
            >上传</el-button
          >
        </div>
      </div>
      <div slot="footer" v-show="speed || uploading" class="footer">
        <ol class="footerSeries">
          <li>关闭弹窗：不会打断上传；</li>
          <li>再次打开：不显示已传完文件；</li>
          <li>再次尝试：需要重新添加源文件；</li>
        </ol>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Scheduler } from "@/utils/index.js";
import { getPolicyByFolder } from "@/api/videoMange/oss_base_api.js"; //上传目录跟文件名的
import { addFile } from "@/api/resourcesManage/studyService.js"; //添加文件

import OSS from "ali-oss";
import upfileStep1 from "./upfileStep1";
import upfileStep2 from "./upfileStep2";

export default {
  data() {
    return {
      upList: [],
      scheduler: {},
      uploading: false,
      ossClient: undefined,
      promiseList: [],
      dirId: "",
      uploadIndex: [0, 1, 2], // 当前待上传索引序列 默认前三个
    };
  },
  components: {
    upfileStep1,
    upfileStep2,
  },
  props: {
    showDialog: Boolean,
    speed: Boolean,
  },
  computed: {
    showSpeed() {
      const speed = !this.speed && !this.uploading;
      return speed;
    },
  },
  created() {
    this.scheduler = new Scheduler();
  },
  methods: {
    /**
     * 创建任务
     * v   时间
     * i   索引 上传文件的索引
     */
    createTask(ossConfig, v, i) {
      this.scheduler.add(() =>
        this.ossPromise(ossConfig, v, i).then(() => console.log(i, "===iiii"))
      );
    },
    //promise上传文件，
    /**
     * ossConfig  文件的参数
     * 
     * i 文件的id
     */
    ossPromise(ossConfig, v, i) {
      // console.log(ossConfig, "promiseossConfig");
      return new Promise((resolve) => {
        console.log(ossConfig.key, "ossConfig.key");
        try {
          //oss分片上传   
          //ossConfig.key  上传的文件的目录    ossConfig.raw 上传的文件流
          this.ossClient
            .multipartUpload(ossConfig.key, ossConfig.raw, {
              //progress:表示进度回调函数，用于获取上传进度，可以是async的函数形式
              progress: (p, checkpoint) =>
                this.onMultipartUploadProgress(p, checkpoint, i),
            })
            .then((res) => {
              console.log(res,'上传的结果');
              resolve();
              this.save(i);
            })
            .catch((e) => {
              console.log("oss error", e);
              v.percentage = -1;
              resolve();
            });
        } catch (e) {
          if (e.code === "ConnectionTimeoutError") console.log("TimeoutError");
          v.percentage = -1;
        }
      });
    },

    //Dialog 打开的回调
    open() {
      let uped = false;
      for (let index = 0, len = this.upList.length; index < len; index++) {
        const v = this.upList[index] || {};
        if (v.percentage != 100) continue;
        this.upList.splice(index, 1);
        uped = true;
        index--;
      }
      return uped;
    },
    //关闭规划框
    async close() {
      const uped = this.open();
      this.promiseList = [];
      this.$refs.fileStep1.currentUpList = [];
      this.uploading = false;
      this.$emit("showdir", {
        bool: false,
        speed: undefined,
        isUped: uped,
      });
    },

    /**
     * 初始化oss
     */
    initOSS(ossConfig) {
      let str = ossConfig.host.split('.');
        str  = str[1]+"."+str[2]+"."+str[3]
        // console.log(str,'[------]');
      try {
        this.ossClient = new OSS({
          // endpoint: ossConfig.host,
          // endpoint: "oss-cn-beijing.aliyuncs.com",//表示OSS对外服务的访问域名
          // region: ossConfig.region,//地域表示 OSS 的数据中心所在物理位置。
          endpoint:str,
          region:ossConfig.region,
          //OSS通过使用AccessKeyId 和AccessKeySecret对称加密的方法来验证某个请求的发送者身份
          accessKeyId: ossConfig.OSSAccessKeyId,
          accessKeySecret: ossConfig.accessSecret,
          stsToken: ossConfig.policy,
          bucket: ossConfig.bucket,
          // bucket: "yjzs-release-video",//存储的空间
          // cname: true,
          // secure: true,
        });
      } catch (e) {
        console.error(e);
      }
    },

    pushListFun(item) {
      this.upList.push(item);
    },
    removeList(index) {
      const len = this.upList.length;
      if (index >= len) return;
      this.upList.splice(index, 1);
      // console.log(this.upList, 'IIIIIII')
    },
    setDirId(path) {
      this.dirId = path;
    },
    //开始上传
    startUpload() {
      const that = this;
      let item = {};
      const obj = Object.assign({}, this.upList);
      Object.keys(obj).forEach(function (key) {
        item = Object.assign({}, obj[key]);
        // console.log(item,'开始上传item');
        that.initOSS(item.ossConfig);
        that.createTask(item.ossConfig, obj[key], key);
      });
      this.scheduler.taskStart();
      this.uploading = true;
    },

    //点击上传
    async actionUpFile() {
      this.$refs.fileStep1.$refs.form.validate((valid) => {
        if (!valid) return;
        for (let i = 0; i < this.upList.length; i++) {
          this.promiseList.push(
            new Promise((resolve, reject) => {
              //调用oss  获取上传文件的信息
              getPolicyByFolder({
                folderId: this.dirId, //目录id
                fileName: this.upList[i].name, //上传的文件名
              })
                .then((r) => {
                  console.log(r,'--文件上传');
                  const fileName = r.fileName; //文件的名字
                  const ossConfig = {};
                  ossConfig.raw = this.upList[i].raw; //文件流
                  ossConfig.name = fileName; //上传的文件名
                  ossConfig.key = r.dir + fileName; //文件目录
                  ossConfig.policy = r.policy;
                  ossConfig.OSSAccessKeyId = r.accessId;
                  ossConfig.accessSecret = r.accessSecret;
                  ossConfig.host = r.host; //网络地址
                  ossConfig.region = r.region;
                  // ossConfig.region = "oss-cn-beijing";
                  // ossConfig.bucket = "yjzs-release-video";
                  ossConfig.bucket = r.bucket;
                  this.upList[i].ossConfig = ossConfig; //文件的信息
                  this.upList[i].creatTime = new Date().getTime(); //时间
                  // console.log(ossConfig,'====ossConfig===');
                  resolve(this.upList[i]);
                })
                .catch((e) => {
                  // this.upList = []
                  // this.promiseList = []
                  this.upList[i].percentage = -2;
                  this.upList[i].creatTime = new Date().getTime();
                  resolve(this.upList[i]);
                });
            })
          );
        }
        //所有文件都配置完成
        Promise.all(this.promiseList)
          .then((rspList) => {
            // console.log(rspList,'rspList');
          })
          .then(() => {
            //加载完毕 开始上传
            this.startUpload();
          });
      });
    },
    async getFolder(v, i) {
      await getPolicyByFolder({
        folderId: this.dirId,
        fileName: v.name,
      })
        .then((r) => {
          const fileName = r.fileName;
          const ossConfig = {};
          ossConfig.name = fileName;
          ossConfig.key = r.dir + fileName;
          ossConfig.policy = r.policy;
          ossConfig.OSSAccessKeyId = r.accessId;
          ossConfig.accessSecret = r.accessSecret;
          ossConfig.host = r.host;
          ossConfig.region = r.region
          // ossConfig.region = "oss-cn-beijing";
          // ossConfig.bucket = "yjzs-release-video";
          ossConfig.bucket = r.bucket;

          v.ossConfig = ossConfig;
          this.initOSS(ossConfig);
          try {
            this.ossClient
              .multipartUpload(ossConfig.key, v.raw, {
                progress: (p, checkpoint) =>
                  this.onMultipartUploadProgress(p, checkpoint, i),
              })
              .then((res) => {
                this.save(i);
              })
              .catch((e) => {
                console.log("000000-", e);
                v.percentage = -1;
              });
          } catch (e) {
            console.error(e);
            v.percentage = -1;
          }
          v.creatTime = new Date().getTime();
          return v;
        })
        .catch((e) => {
          // console.log(v);
          v.percentage = -2;
          v.creatTime = new Date().getTime();
        });
    },
    async save(index) {
      const element = this.upList[index];
      const p = {
        fileSize: element.size,
        ossUrl: this.$Cfg.fileGetUrl + element.ossConfig.key,
        fileName: element.name,
        folderId: this.dirId,
      };
      // console.log(p,'===ppp===');
      // return
      //校验名字知否存在
      await addFile(p)
        .then((res) => {
          // this.upList.splice(index, 1);
        })
        .catch((e) => {
          this.upList[index].percentage = -1; //设置百分比
        });
    },
    onMultipartUploadProgress(p, checkpoint, i) {
      // 断点记录点。浏览器重启后无法直接继续上传，需要手动触发上传操作。
      this.isShow = p !== 1;
      this.upList[i].percentage = p * 100;
      this.upList[i].currentPercentage = p * 100;
      if (!this.upList[i].checkpoint) this.upList[i].checkpoint = {};
      this.upList[i].checkpoint[checkpoint.uploadId] = checkpoint;
    },

    //删除文件
    remove(scope) {
      if (this.ossClient) this.ossClient.cancel();
      this.upList.splice(scope.$index, 1);
      // console.log(scope)
    },

    //再次尝试
    tryAgain(scope) {
      this.getFolder(scope.row, scope.$index);
    },
  },
};
</script>
<style lang="scss" scoped>
.footer {
  text-align: left;
  padding: 0;
  color: #aaa;
  font-weight: 400;

  .footerSeries {
    margin-left: 1.3em;
    margin-top: 0.5em;
    line-height: 1.1em;
  }
}

.item_big {
  padding-right: 16px;
  display: flex;
  justify-content: space-between;

  .labelStyle,
  .valueStyle {
    font-size: 15px;
    line-height: 3em;
  }

  .labelStyle {
    color: #868888;
    flex-shrink: 0;
  }

  .valueStyle {
    text-align: left;
    flex-grow: 1;
    padding-left: 16px;
  }
}
</style>
